import { jsx as l } from "react/jsx-runtime";
const c = (o) => /* @__PURE__ */ l(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 64 64",
    ...o,
    children: /* @__PURE__ */ l(
      "path",
      {
        fill: "currentColor",
        d: "M51.503 14.94c-4.873-4.84-13.425-4.836-18.302.01l-1.196 1.212-1.197-1.227c-2.309-2.29-5.643-3.604-9.149-3.604-3.509 0-6.827 1.314-9.103 3.604-2.423 2.408-3.754 5.644-3.754 9.117-.016 3.482 1.31 6.73 3.733 9.154l19.48 19.481 19.5-19.478.342-.372c2.216-2.414 3.401-5.613 3.339-9.01-.062-3.404-1.374-6.56-3.693-8.888Zm-2.846 15.445L32.005 47.029 15.38 30.366c-1.67-1.655-2.584-3.894-2.569-6.3 0-2.408.917-4.648 2.583-6.298 1.626-1.642 3.857-2.55 6.273-2.55 2.41 0 4.647.908 6.296 2.558l4.051 4.065 4.05-4.053c1.573-1.587 3.868-2.5 6.293-2.5 2.425 0 4.722.915 6.304 2.51 1.646 1.64 2.556 3.871 2.556 6.28 0 2.409-.909 4.648-2.56 6.307Z"
      }
    )
  }
);
export {
  c as Heart
};
